import React, { Fragment, useMemo, useState } from 'react';
import Requirement from '../components/forms/Requirement';
import toast from 'react-hot-toast';
import { fetchRequirements } from '../hooks/queries';
import { useNavigate } from 'react-router-dom';
import Modal from '../components/common/Modal';
import { BtnPrimary } from '../components/common/Buttons';
import TableWithSearchCTA from '../components/TableWithSearchCTA';
import { useRequirementColumns } from '../components/columns/useRequirementCol';
import { requirementStatusOptions } from '../constants';

const RCSE: React.FC = () => {
  const navigate = useNavigate();
  const [isRequirementOpen, setIsRequirementOpen] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState<string | null>('active');

  const {
    data: requirements,
    isLoading,
    isFetching,
    error,
    refetch,
  } = fetchRequirements();

  const columnDefs = useRequirementColumns({
    onView: (data) => {
      navigate(`/clients/rcse/${data._id}`);
    },
  });

  const filteredRequirements = useMemo(() => {
    if (selectedStatus && selectedStatus !== '') {
      return requirements?.data?.filter(
        (requirement) => requirement.status === selectedStatus
      );
    }
    return requirements?.data;
  }, [requirements?.data, selectedStatus]);

  const handleStatusSelect = (s: string) => {
    setSelectedStatus(s);
  };

  const statusOptions = [
    ...requirementStatusOptions,
    { value: '', label: 'All' },
  ];

  return (
    <div className="relative w-full h-full">
      <TableWithSearchCTA
        rowData={filteredRequirements ?? []}
        columnDefs={columnDefs}
        ctas={{
          enableExportToCsv: true,
          custom: (
            <Fragment>
              <BtnPrimary onClick={() => setIsRequirementOpen(true)}>
                + Create
              </BtnPrimary>
            </Fragment>
          ),
        }}
        headerTitle="Requirements"
        isLoading={isLoading}
        isFetching={isFetching}
        error={error as Error}
        refetch={refetch}
        enableRefresh
        storageKey="requirements_table"
        allStatuses={statusOptions}
        selectedStatus={selectedStatus ?? ''}
        onStatusSelect={handleStatusSelect}
      />

      {/* Create/Edit Modal */}
      <Modal
        isOpen={isRequirementOpen}
        onRequestClose={() => setIsRequirementOpen(false)}
        title="Create Requirement"
        width="60%"
      >
        <Requirement
          onSuccess={() => {
            setIsRequirementOpen(false);
            toast.success('Requirement saved successfully');
            refetch();
          }}
          onError={(e) => toast.error(e.message)}
        />
      </Modal>
    </div>
  );
};

export default RCSE;
